import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { QuestionnairePageComponent } from './containers/questionnaire-page/questionnaire-page.component';

const routes: Routes = [
  {
    path: ':id',
    component: QuestionnairePageComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class QuestionnairesRoutingModule {
}
